import React from "react";
import { Link } from "react-router-dom";

const ProfileNav = ({ onLogout, candidate_type, is_candidate }) => {
  const handleLinkClick = (e) => {
    // Stop event propagation to prevent parent click handlers
    e.stopPropagation();
  };

  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onLogout();
  };

  // Determine the link destination based on candidate_type
  const getAccountSettingsLink = () => {
    if (candidate_type === 'candidate') {
      return '/candidate/userprofile';
    } else if (candidate_type === 'client') {
      return '/manager/account-settings';
    } else {
     return '/settings';
    }
  };

  return (
    <div className="absolute top-12 right-0 bg-white border border-gray-200 rounded-md shadow-lg w-48 z-50">
      <ul>
        <li className="px-4 py-2 hover:bg-gray-100">
          <Link 
            to={getAccountSettingsLink()}
            onClick={handleLinkClick}
            className="block w-full text-black"
          >
            Account Settings
          </Link>
        </li>
        <li className="px-4 py-2 hover:bg-gray-100">
          <button 
            onClick={handleLogout} 
            className="w-full text-left text-black"
          >
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ProfileNav;